import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { Stack } from "./StackBlock";
import { defaultData } from "./StackBlockDefaultData";
import { meta } from "./StackBlockMetaData";

export const StackBlock: BlockExport = {
  type: "component",
  Block: Stack,
  imagePreview: {
    type: "icon",
    name: "24-builder-element-stack",
    size: 24,
  },
  defaultData,
  meta,
};
